import { render, staticRenderFns } from "./_Collection.vue?vue&type=template&id=8bf9865a&"
import script from "./_Collection.vue?vue&type=script&lang=js&"
export * from "./_Collection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports